import React from 'react';
import { IProps } from 'components/Accordion/Addition/types';

const Addition: React.FC<IProps> = (props) => {
  return (
    <div className="accordion__item-addition">
      {props.children}
    </div>
  );
};

export default Addition;
